import { Flex, Avatar, Text } from '@chakra-ui/react';
import { CenterSpinner } from '@/components/ats';
import { useGetInterviewerPool, type InterviewerPoolUser } from '@/api';

const InterviewerTag = ({
  interviewer,
}: {
  interviewer: InterviewerPoolUser;
}) => (
  <Flex
    gap="8px"
    p="8px"
    border="1px solid"
    borderColor="border-color"
    borderRadius="xs"
    bg="ats-secondary"
  >
    <Avatar
      name={interviewer?.name}
      src={interviewer?.avatar_url}
      width="20px"
      height="20px"
      className="avatar-sm"
    />
    <Text fontSize="sm">{interviewer?.name}</Text>
  </Flex>
);

interface InterviewPoolListProps {
  value?: number | string | null;
}

/** Renders all members of the selected pool below the field (after content). */
export const InterviewPoolList = ({ value }: InterviewPoolListProps) => {
  const { interviewerPool, isLoading } = useGetInterviewerPool({ id: value });
  const members = interviewerPool?.users ?? [];

  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (isLoading) {
    return <CenterSpinner height="40px" />;
  }

  return (
    <Flex
      bg="ats-tertiary"
      p="xl"
      mt="sm"
      borderRadius="xs"
      flexWrap="wrap"
      gap="6px"
    >
      {members.map((interviewer) => (
        <InterviewerTag interviewer={interviewer} key={interviewer.id} />
      ))}
    </Flex>
  );
};
